<template>
    <div class="home-page">
		<Header></Header>
    <div class="home-search disflex">
      <input ref="input" v-model="keywords" @blur="getSearch(keywords,1)"
        @keyup.enter.native="getSearch($event,1)" class="input" />
      <img @click="getSearch(keywords,1)" src="../../static/images/search-icon.png" />
    </div>
		<div class="list" v-if="list.length>0">
      <div class="home1-product2">
        <div class="product2-content disflex">
          <div class="list-content" v-for="(item,index) in list">
            <div class="name-title ovhidden" @click="goPlay(item.game_id)">
              {{item.title}}
            </div>
            <div class="list-img">
              <img :src="item.icon_image" @click="goPlay(item.game_id)" />
            </div>
            <div class="list-center">
            </div>
            <button class="btn btn-blue" @click="goPlay(item.game_id)">{{$t('play')}}</button>
          </div>
        </div>
      </div>
      <div class="more ac mt20" v-if="isShow2" @click="getMore">
        <span>{{$t('showMore')}}</span>
      </div>
		</div>
    <div class="ac mt100" v-else>
      <img src="../../static/images/nofind.png" />
      <div class="mt50 fs50" v-html="$t('noFound')"></div>
    </div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page:1,
			limit:5,
			isShow:'All',
			isShow2:true,
      keywords:'',
      isSearch:false,
      isType:''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    this.keywords = this.$route.query.keywords
		this.getSearch();
	},
    methods: {
		back(){
			this.$router.push({path:'/index'})
		},
    getList(item){
      this.isShow = item
      this.type_id = item.type_id
      this.list = []
      this.page = 1
      this.getHome();
    },
    goPlay(game_id){
      this.$router.push({path:'/game',query:{game_id:game_id,keywords:this.keywords}});
    },
		getMore(){
			let that = this;
			if(that.isShow2){
				that.page++;
        that.getSearch();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
    getSearch(keywords,type){
      let that =this;
      if(type==1){
        that.page = 1
        that.list = []
      }
      that.$parent.loadModal(true);
      let data = {
        'page':that.page,
        'keywords':that.keywords
      }
      that.$api.post('/api/game/search',data,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
      		if(r.data.length>0){
            if(that.page>1){
              that.list = that.list.concat(r.data)
            }else{
              that.list = r.data
            }
            if(r.data.length==10){
              that.isShow2 = true;
            }else{
              that.isShow2 = false;
            }

      		}else{
      			that.isShow2 = false;
      			//that.$utils.alertText(that.$t('noMore'));
      		}
          console.log(that.list)
        });

      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/searchList.vue